import { JobStatus } from '../../../enums/job-status.enum';
import { ShiftStatus } from '../../../interfaces/shift-status.interface';

export class ChangeJobStatus {
    public static readonly type = '[JobsPlacements] Change job status';

    constructor(public id: number, public status: JobStatus, public shiftsStatuses?: Array<ShiftStatus>) { }
}
